import React from 'react';

function VistaPreviaImportacion({ visible, datos, onConfirmar, onCancelar }) {
  if (!visible || !Array.isArray(datos)) return null;

  return (
    <div className="full-modal">
      <div className="modal-content" style={{ maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' }}>
        <h3>👁️ Vista previa de importación</h3>
        <p>Se importarán <strong>{datos.length}</strong> clientes con sus respectivos ordenadores.</p>

        <table className="tabla-clientes" style={{ marginBottom: '1rem' }}>
          <thead>
            <tr>
              <th>Código</th>
              <th>Cliente</th>
              <th>Teléfono</th>
              <th>Observaciones</th>
              <th>Ordenadores</th>
            </tr>
          </thead>
          <tbody>
            {datos.map((cliente, index) => (
              <tr key={index}>
                <td>{cliente.codigo_cliente}</td>
                <td>{cliente.nombre}</td>
                <td>{cliente.telefono}</td>
                <td>{cliente.observaciones}</td>
                <td>
                  <ul style={{ margin: 0, paddingLeft: '1.2rem' }}>
                    {cliente.ordenadores.map((o, i) => (
                      <li key={i}>{o.descripcion} — {o.info_adicional}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="button-group">
          <button className="button primary" onClick={onConfirmar}>✅ Confirmar importación</button>
          <button className="button danger" onClick={onCancelar}>❌ Cancelar</button>
        </div>
      </div>
    </div>
  );
}

export default VistaPreviaImportacion;
